export interface PlanHistoryCrudresponse {
  message: string
  status: number
  info: PlanHistoryResponse
}

export interface IPaymentTransactionDetails {
  // Common Fields
  origin: EPaymentOrigin

  // Stripe Only Fields
  priceId: string
  productId: string
  paymentMethodId: string
  paymentMethodLastDigits: string
  invoiceId: string
  pricePaid: number
  currency: string
}

export interface PlanHistoryItem {
  _id?: string
  date: string // Date as string from API
  quantity: number
  transactionDetails?: IPaymentTransactionDetails
  recordType: ECreditRecordType
}

export interface PlanHistoryResponse {
  page: number
  size: number
  pages: number
  totalItems: number
  currentItems: number
  rechargeHistory: PlanHistoryItem[]
}

export interface PlanHistoryRequest {
  page: number
  pageSize: number
}

export enum ECreditRecordType {
  ACCREDITATION = 'Accreditation',
  REFOUND = 'Refound',
  BURNED = 'Burned',
  DISCOUNT = 'Discount',
  EXPIRATION = 'Expiration',
}
export enum EPaymentOrigin {
  STRIPE = 'stripe',
  BO = 'backoffice',
  API = 'api',
}

export enum EPlanStatus {
  ACTIVE = 'active',
  CANCELED = 'canceled',
  INCOMPLETE = 'incomplete',
  INCOMPLETE_EXPIRED = 'incomplete_expired',
  PAST_DUE = 'past_due',
  PAUSED = 'paused',
  TRIALING = 'trialing',
  UNPAID = 'unpaid',
}

// New Stripe API Types
export interface TopupPrice {
  id: string
  unitAmount: number // In cents
  currency: string
  credits?: number
}

export interface PricingProduct {
  productId: string
  priceId: string
  type: 'onetime' | 'monthly' | 'annual' | 'topup'
  name: string
  description: string
  imageUrl: string
  credits: number
  currency: string
  amount: number
  formattedPrice: string
  discount?: number
  originalAmount?: number
  formattedOriginalPrice?: string
  isRecurring: boolean
  interval?: 'month' | 'year'
}

export interface PricingTableResponse {
  products: PricingProduct[]
  detectedCountry: string
  detectedCurrency: string
}

export interface TopupProduct {
  productId: string
  priceId: string
  type: 'onetime' | 'monthly' | 'annual' | 'topup'
  name: string
  description: string
  imageUrl: string
  credits: number
  currency: string
  amount: number
  formattedPrice: string // e.g., "$10.00"
  discount?: number // percentage, e.g., 30
  originalAmount?: number // price before discount
  formattedOriginalPrice?: string // e.g., "$15.00"
  isRecurring: boolean // true for monthly/annual
  interval?: 'month' | 'year' // only for recurring
}

export interface TopupProductResponse {
  product: TopupProduct
  detectedCountry?: string
  detectedCurrency?: string
}

export interface LineItem {
  price?: string // Stripe price ID
  quantity?: number
  amount?: number // For custom amounts (cents)
  currency?: string // Required if amount provided
  name?: string // For custom items
}

export interface CreateCheckoutSessionDto {
  mode: 'payment' | 'subscription'
  lineItems: LineItem[]
  successUrl: string
  cancelUrl: string
  customerId?: string
  customerEmail?: string
  allowPromotionCodes?: boolean
  metadata?: Record<string, string>
  idempotencyKey?: string
}

export interface CheckoutSessionResponse {
  id: string
  object: string
  url: string
  mode: string
  status: string
  customer?: string
  payment_status: string
  amount_total: number
  currency: string
  metadata?: Record<string, string>
  success_url: string
  cancel_url: string
}

export interface CreatePortalSessionDto {
  customerId: string
  returnUrl: string
}

export interface PortalSessionResponse {
  id: string
  object: string
  url: string
  customer: string
  return_url: string
  created: number
  livemode: boolean
}

export interface RetrieveCheckoutSessionRequestDto {
  sessionId: string
}

export interface CreatePricingTableSessionDto {
  customerId: string
}
